import { VhcRecordLogService, VHCRecordPartInput } from 'api/generated';
import { ApiMutationOptions, useMutationWithNotifications } from 'api/utils/useMutationWithNotifications';

export type UpdateBreakPartsInput = {
  logId: number;
  itemId: number;
  partId: number;
  requestBody?: VHCRecordPartInput;
};

export const useUpdateBreakPartsMutation = (
  options?: ApiMutationOptions<typeof VhcRecordLogService.putVhcRecordsItemsBrakesParts, UpdateBreakPartsInput>
) =>
  useMutationWithNotifications(
    ({ logId, itemId, partId, requestBody }: UpdateBreakPartsInput) =>
      VhcRecordLogService.putVhcRecordsItemsBrakesParts(logId, itemId, partId, requestBody),
    options
  );
